export enum ETipoStatusPagamento {
    CREATED = "Criado",
    PRE_PAID = "Pré Pago",
    PAID = "Pago",
    PARTIALLY_PAID = "Parcialmente Pago",
    PENDING = "Pendente",
    DENIED = "Negado",
    CANCELED = "Cancelado",
    PARTIALLY_CANCELED = "Parcialmente Cancelado",
    EXPIRED = "Expirado",
}